export const TradeFooter = () => {
  return null;
};
